import _ from 'underscore';

export const buildDefaultTextProperty = (props) => {
  const {
    label,
    text,
    styles,
    isRendered,
    dynamicProps,
  } = props;

  const baselineProperty = {
    type: 'property-row',
    isRendered,
    propertyLabel: {
      label,
    },
    components: {
      text: {
        type: 'text',
        text,
        dynamicProps,
      },
    },
  };

  return _.extend(baselineProperty, { styles });
};
